import DropShippingProductType from "@/enum/DropShippingProductType";
import { get, post } from "@/services/http/platformServer";

export interface DropShippingSkuAssociation {
    id: number;

    productId: number;

    supplierProductId: number;

    supplierSkuId: number;

    supplierCompanyId: number;

    supplierShopId?: number;
}

interface AssociationProductParams {
    productAssociationParam?: {
        retailerProductId: number;
        supplierSkuId?: number;
    };

    retailerShopId: number;

    skuAssociationParam?: {
        retailerSkuId?: number;
        supplierSkuId?: number;
    };

    supplierShopId: number;
}

/** 分销商品关联，仅支持单个商品或者sku关联 */
export function associationProduct(shopId, params: AssociationProductParams): Promise<DropShippingSkuAssociation> {
    return post(shopId, "/drop_shipping_product/association", params);
}

interface DeleteDropshippingProductAssociation {
    retailerProductId?: number;
    retailerShopId: number;
    retailerSkuId?: number;
}

/** 删除商品关联 */
export function deleteDropshippingProductAssociation(params: DeleteDropshippingProductAssociation): Promise<void> {
    return post(params.retailerShopId, "/drop_shipping_product/association/delete", params);
}

interface UpdateSkuType {
    id: number;
    skuType: DropShippingProductType;
}

interface UpdateTypeParams {
    id: number;
    productType: DropShippingProductType;
    updateSkuTypes?: UpdateSkuType[];
}

/**代理商修改商品类型 */
export function updateType(shopId, params: UpdateTypeParams): Promise<void> {
    return post(shopId, "/drop_shipping_product/update_type", { shopId, ...params });
}
export interface ProductAssociationParams {
    retailerProductId: number;
    supplierSkuIds?: number[];
}

export interface SkuAssociationParams {
    retailerSkuId: number;
    supplierSkuIds?: number[];
}

export interface BatchAssociationProductParams {
    productAssociationParams?: ProductAssociationParams[];
    retailerShopId: number;
    skuAssociationParams?: SkuAssociationParams[];
    supplierShopId: number;
}

export enum ProductBatchAssociationProcessStatus {
    COMPLETED = "COMPLETED",

    ERROR = "ERROR",

    RUNNING = "RUNNING",
}

interface ProductBatchAssociationProcess {
    errorMsg?: string;
    status: ProductBatchAssociationProcessStatus;
    taskId: string;
}

/** 批量关联商品 */
export function batchAssociationProduct(
    shopId,
    associationList: BatchAssociationProductParams,
): Promise<ProductBatchAssociationProcess> {
    return post(shopId, "/drop_shipping_product/batch_association", associationList);
}

export function getBatchAssociationProcess(shopId, taskId): Promise<ProductBatchAssociationProcess> {
    return get(shopId, "/drop_shipping_product/batch_association_process", { taskId });
}
